import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import classnames from 'classnames';
import { FaExclamationTriangle } from 'react-icons/fa';

export const InputFeedback = ({ error }) =>
  error ? (
    <div className='input-feedback'>
      <FaExclamationTriangle />
      {error}
    </div>
  ) : null;

export const label = ({ error, className, children, ...props }) => (
  <Label className='label' {...props}>
    {children}
  </Label>
);

export const TextInput = ({
  type,
  placeholder,
  id,
  label,
  error,
  value,
  defaultValue,
  onChange,
  className,
  labelClassName,
  limitLength,
  ...props
}) => {
  const classes = classnames({ formError: !!error }, className);
  return (
    <FormGroup className={classes}>
      <Label htmlFor={id} className={labelClassName}>
        {label}
      </Label>
      <Input
        id={id}
        className='text-input form-control'
        type={type}
        placeholder={placeholder}
        defaultValue={defaultValue}
        value={value}
        maxLength={limitLength}
        onChange={onChange}
        {...props}
      />
      <InputFeedback error={error || null} />
    </FormGroup>
  );
};

export const SelectInput = ({
  type,
  id,
  label,
  error,
  value,
  onChange,
  className,
  labelClassName,
  ...props
}) => {
  const classes = classnames({ formError: !!error }, className);
  const { optionsData } = props;
  const handleChange = (event) => {
    onChange([id], event.target.value);
  };
  return (
    <FormGroup className={classes}>
      <Label className={labelClassName}>{label}</Label>
      <Input
        type='select'
        id={id}
        defaultValue={value}
        className={className}
        onChange={handleChange}
        onBlur={props.onBlur}
      >
        <option key={99} value={null}>
          --
        </option>
        {optionsData && optionsData.data
          ? optionsData.data.map((option, index) => (
              <option key={index} value={option[optionsData.key]}>
                {option[optionsData.value]}
              </option>
            ))
          : ''}
      </Input>
      <InputFeedback error={error || ''} />
    </FormGroup>
  );
};

export const CheckBoxes = ({
  type,
  id,
  label,
  error,
  value,
  onChange,
  className,
  labelClassName,
  ...props
}) => {
  const classes = classnames({ formError: !!error }, className);
  const { optionsData } = props;

  return (
    <FormGroup check className={classes}>
      {optionsData && optionsData.data
        ? optionsData.data.map((option, index) => (
            <Label>
              <Input
                type='checkbox'
                key={index}
                name={id}
                // checked={checked}
                onChange={onChange}
                value={option[optionsData.key]}
                {...props}
              />
              {option[optionsData.value]}
            </Label>
          ))
        : ''}
    </FormGroup>
  );
};

export class CheckboxGroup extends React.Component {
  handleChange = (event) => {
    const target = event.currentTarget;
    const valueArray = [...this.props.value] || [];

    if (target.checked) {
      valueArray.push(target.id);
    } else {
      valueArray.splice(valueArray.indexOf(target.id), 1);
    }

    this.props.onChange(this.props.id, valueArray);
  };

  handleBlur = () => {
    this.props.onBlur(this.props.id, true);
  };

  render() {
    const { value, error, touched, label, className, children } = this.props;
    return (
      <div className={className}>
        <fieldset>
          <legend>{label}</legend>
          {React.Children.map(children, (child) =>
            React.cloneElement(child, {
              field: {
                value: value.includes(`${child.props.id}`),
                onChange: this.handleChange,
                onBlur: this.handleBlur,
              },
            }),
          )}
          {touched && <InputFeedback error={error} />}
        </fieldset>
      </div>
    );
  }
}

export const Checkbox = ({
  field: { name, value, onChange, onBlur },
  form: { errors, touched, setFieldValue },
  id,
  label,
  className,
  ...props
}) => (
  <div>
    <input
      name={name}
      id={id}
      type='checkbox'
      value={value}
      checked={value}
      onChange={onChange}
      onBlur={onBlur}
    />
    <label style={{ marginLeft: '5px', display: 'initial' }} htmlFor={id}>
      {label}
    </label>
    {touched[name] && <InputFeedback error={errors[name]} />}
  </div>
);
